import { defineMessages } from 'react-intl';

export const variationSelectionDialogMessages = defineMessages({
  headline: {
    id: 'product.variationSelect.select.dialog.headline',
    defaultMessage: 'Bitte {dimension} wählen',
  },
});
